import { gql } from '@apollo/client';
export const CONTROL_FIELDS = gql`
  fragment ControlFields on ControlDto {
    id
    code
    label
    status
    groupId
    groupName
    externalId
    objectId
  }
`;